export const localDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const lastThirtyDays = (today = new Date()) => {
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
  return { dateFrom: localDate(start), dateTo: localDate(today) };
};

export const validateReportDates = ({ dateFrom, dateTo }) => {
  const validDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value)
    && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value;
  if ((dateFrom && !validDate(dateFrom)) || (dateTo && !validDate(dateTo))) return 'Enter valid report dates.';
  if (dateFrom && dateTo && dateFrom > dateTo) return 'Start date must be on or before end date.';
  return '';
};

const addCalendarMonths = (value, months) => {
  const [year, month, day] = value.split('-').map(Number);
  const targetMonth = month - 1 + months;
  const lastDay = new Date(year, targetMonth + 1, 0).getDate();
  return localDate(new Date(year, targetMonth, Math.min(day, lastDay)));
};

/**
 * Large and open-ended ranges are generated outside the request/response cycle.
 * Calendar months are intentional: Jan 31 through Jul 31 is exactly six months,
 * while Aug 1 is over the limit. Month-end dates clamp in the same way as the
 * report presets (for example, Aug 31 + 6 months is Feb 28/29).
 */
export const requiresAsyncReport = ({ dateFrom, dateTo }) => {
  if (!dateFrom || !dateTo) return true;
  if (validateReportDates({ dateFrom, dateTo })) return false;
  return dateTo > addCalendarMonths(dateFrom, 6);
};

export const reportParams = (filters) => Object.fromEntries(Object.entries(filters)
  .filter(([, value]) => value !== '' && value !== 'all'));

export const categoryLabel = (category) => category === 'retreaded' ? 'Retreaded' : category === 'new' ? 'New (first life)' : 'Unknown';

export const editableJobFilters = (filters = {}) => ({
  dateFrom: filters.dateFrom || filters.date_from || '',
  dateTo: filters.dateTo || filters.date_to || '',
  vehicleId: String(filters.vehicleId ?? filters.vehicle_id ?? ''),
  status: filters.status || 'all',
  category: filters.category || 'all',
});
